function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import { LogLevel } from '@sky-uk-ott/core-video-sdk-js-logger';
import { CoreVideoInternal } from '../../core-video-internal';
import { JsonUtils } from '../json-utils';
import { createErrorLoggingObservable } from './error-logging-observable';
import { createErrorLogger, Observable } from './observable';
export function createLoggingObservable(name, logger) {
    if (logger.getLogLevel() === LogLevel.Verbose) {
        var verboseLogger = function(logValue) {
            logger.verbose("".concat(name, ":"), logValue);
        };
        return new VerboseLoggingObservable(verboseLogger, createErrorLogger(name, logger));
    }
    return createErrorLoggingObservable(name, logger);
}
var VerboseLoggingObservable = /*#__PURE__*/ function(Observable) {
    "use strict";
    _inherits(VerboseLoggingObservable, Observable);
    function VerboseLoggingObservable(verboseLoggingHandler, errorHandler) {
        _class_call_check(this, VerboseLoggingObservable);
        var _this;
        _this = _call_super(this, VerboseLoggingObservable, [
            errorHandler
        ]), _define_property(_this, "verboseLoggingHandler", void 0), _this.verboseLoggingHandler = verboseLoggingHandler;
        return _this;
    }
    _create_class(VerboseLoggingObservable, [
        {
            key: "notifyObservers",
            value: function notifyObservers(newState, currentPosition) {
                var _CoreVideoInternal_config_staticConfig_debug;
                if ((_CoreVideoInternal_config_staticConfig_debug = CoreVideoInternal.config.staticConfig.debug) === null || _CoreVideoInternal_config_staticConfig_debug === void 0 ? void 0 : _CoreVideoInternal_config_staticConfig_debug.fullySerializedVerboseObservables) {
                    this.verboseLoggingHandler(JsonUtils.stringify(newState));
                } else {
                    this.verboseLoggingHandler((typeof newState === "undefined" ? "undefined" : _type_of(newState)) === 'object' ? 'set sdkConfig.debug.fullySerializedVerboseObservables to log payload' : '' + newState);
                }
                return _get(_get_prototype_of(VerboseLoggingObservable.prototype), "notifyObservers", this).call(this, newState, currentPosition);
            }
        }
    ]);
    return VerboseLoggingObservable;
}(Observable);

//# sourceMappingURL=verbose-logging-observable.js.map